export type RoomOnlyEvents =
  | 'userJoined'
  | 'userLeft'
  | 'phoneUsersJoined'
  | 'phoneUsersLeft'
  | 'streamStarted'
  | 'streamStopped'
  | 'screenshareStarted'
  | 'screenshareStopped'
  | 'externalStreamStarted'
  | 'externalStreamStopped';

export const roomOnlyEvents = [
  'userJoined',
  'userLeft',
  'phoneUsersJoined',
  'phoneUsersLeft',
  'streamStarted',
  'streamStopped',
  'screenshareStarted',
  'screenshareStopped',
  'externalStreamStarted',
  'externalStreamStopped',
];
